/*
 * @Author: your name
 * @Date: 2020-09-11 10:51:23
 * @LastEditTime: 2021-06-24 17:21:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lzxy-homepage\src\pages\home\manages\InformationNewsManage.ts
 */
import { InformationNewsService } from '../services/HomeService'
import { NewsResponse } from '../models/InformationNews'
import { InformationNewsManage } from '../interfaces/InformationNewsManage'
import { IndexInfomationNavModel } from '../model'
class InformationNewsManageImpl implements InformationNewsManage {
  newsInfo: NewsResponse = new NewsResponse([], 0)
  currentPage = 1
  pageSize = 12 // 默认展示20条数据查看更多进入资讯列表页
  menuId = 6
  menuesName = ''
  menuesId = ''
  service: InformationNewsService
  resultArr: Array<any> = []
  // loading: boolean = false
  constructor (service: InformationNewsService) {
    this.service = service
    // this.getmenulist()
  }

  getmenulist () {
    this.service.getInfomationNavs().then((res: Array<IndexInfomationNavModel>) => {
      const menusInfomations = res.map(async (menu: IndexInfomationNavModel) => {
        const menuInfos = await this.service.getInformationNewsService(this.currentPage, this.pageSize, menu.id)
        return menuInfos
      })
      Promise.all(menusInfomations).then((ret: any) => {
        const menuList = ret.map((item: any) => {
          return item.newsList
        })
        console.log(menuList)
        const resultArr = []
        for (const i in menuList) {
          const data = menuList[i]
          for (const j in data) {
            resultArr.push(data[j])
          }
        }
        console.log(resultArr)
        this.resultArr = resultArr
      })
    })
  }

  public async requestInformationNewsData (id?: string, name?: string) {
    // const menues = await this.service.getHomeMenus()
    // console.log(menues)
    // const infosId = menues.filter((item: any) => {
    //   return /(新闻|资讯|信息)/g.test(item.name)
    // })
    // const infoMenusId = infosId ? infosId[0].id : ''
    let infoMenusId = ''
    if (id) {
      infoMenusId = id
    }
    this.menuesId = infoMenusId
    if (name) {
      this.menuesName = name
    }
    const res = await this.service.getInformationNewsService(this.currentPage, this.pageSize, infoMenusId)
    console.log(res)
    this.newsInfo = res
  }

  public setCurrentPage (page: number) {
    this.currentPage = page
    this.requestInformationNewsData(this.menuesId, this.menuesName)
  }

  public setPageSize (pageSize: number) {
    this.pageSize = pageSize
    this.requestInformationNewsData(this.menuesId, this.menuesName)
  }
}
export { InformationNewsManageImpl }
